module.exports = __webpack_public_path__ + "img/icon2.68be5251.svg";